import * as RdxPopover from '@radix-ui/react-popover';
import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

interface IRdxPopoverRoot {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

function RdxPopoverRoot({ children, open, onOpenChange }: IRdxPopoverRoot) {
  return (
    <RdxPopover.Root open={open} onOpenChange={onOpenChange}>
      {children}
    </RdxPopover.Root>
  );
}

function RdxPopoverTrigger({
  children,
  className,
  onClick,
  disabled,
  'aria-label': ariaLabel,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: ClassValue;
  disabled?: boolean;
  'aria-label'?: string;
}) {
  return (
    <RdxPopover.Trigger
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn('border-none outline-none', className)}
      disabled={disabled}
    >
      {children}
    </RdxPopover.Trigger>
  );
}

interface IPopoverContentProps {
  children: React.ReactNode;
  side?: 'right' | 'top' | 'bottom' | 'left';
  sideOffset?: number;
  align?: 'start' | 'center' | 'end' | undefined;
  alignOffset?: number;
  className?: ClassValue;
}

function RdxPopoverContent({
  children,
  side,
  sideOffset,
  align,
  alignOffset,
  className,
}: IPopoverContentProps) {
  return (
    <RdxPopover.Content
      className={cn(
        'bg-surface-elevated text-text-primary z-1 mt-2 rounded-2xl p-2 shadow',
        className,
      )}
      side={side}
      sideOffset={sideOffset}
      align={align}
      alignOffset={alignOffset}
    >
      {children}
    </RdxPopover.Content>
  );
}

export const Popover = {
  Root: RdxPopoverRoot,
  Trigger: RdxPopoverTrigger,
  Content: RdxPopoverContent,
};
